import { SearchParamType } from '@interfaces/search-param-type.interface';

export class CompareParams {
  searchParamType: SearchParamType;
  name?: string;
  procedure_id?: string;
  radius?: string;
  locale?: string;
  geo_location?: string;
  search_specialty_id?: string;
  network_id?: string;
  account_id?: string;
  fulltext?: string;

  constructor(obj: CompareParams) {
    if (obj) {
      this.searchParamType = obj.searchParamType;
      this.radius = obj.radius || '';
      this.locale = obj.locale || 'en';
      this.geo_location = obj.geo_location || '';
      this.network_id = obj.network_id || '';
      this.account_id = obj.account_id || '';
      if (obj.name) {
        this.name = obj.name;
      }
      if (obj.procedure_id) {
        this.procedure_id = obj.procedure_id;
      }
      if (obj.search_specialty_id) {
        this.search_specialty_id = obj.search_specialty_id;
      }
      if (obj.fulltext) {
        this.fulltext = obj.fulltext;
      }
    }
  }
}
